import { PosPlugin } from 'plugins/plugin';
import { getCurrentPosLanguage } from 'reducers/configs/settings';
import { getClientCode } from 'reducers/Login';

import { checkPasswordExpiration } from './checkPasswordExpiration';

export const checkPasswordExpirationAndShowConfirmation: Required<
  PosPlugin
>['onMount'] = () => checkPasswordExpiration;

/**
 * Workaround: Mark this account as being an MM account (including the language used)
 *
 * Workaround currently used to:
 *  * Customize the text displayed after login if the password is expired
 */
export function markAsMmAccount() {
  return async function thunkAction(dispatch, getState) {
    const lang = getCurrentPosLanguage(getState()) === 'fr' ? 'fr' : 'en';
    localStorage.setItem(
      'workaround:isMmAccount',
      `${getClientCode(getState())}-${lang}`,
    );
  };
}

export { usePasswordRotationEarlyWarning } from './usePasswordRotationEarlyWarning';
